/**
 * SEO Configuration - White-Label Architecture
 * Uses brand configuration for dynamic SEO values
 */

import brand from './brand';

// Configuration SEO dynamique basée sur la marque
export const seoConfig = {
  siteName: brand.name,
  siteUrl: brand.domain,
  defaultTitle: brand.seo.defaultTitle,
  defaultDescription: brand.seo.defaultDescription,
  defaultImage: `${brand.domain}${brand.logo}`,
  twitterHandle: brand.social.twitter || '',
  
  // Mots-clés stratégiques
  keywords: brand.seo.keywords,
  
  // Informations entreprise (Schema.org Organization)
  organization: {
    name: brand.name,
    legalName: brand.legalName,
    url: brand.domain,
    logo: `${brand.domain}${brand.logo}`,
    description: brand.seo.defaultDescription,
    email: brand.contact.email,
    telephone: brand.contact.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: brand.contact.address.street,
      addressLocality: brand.contact.address.city,
      postalCode: brand.contact.address.postalCode,
      addressCountry: brand.contact.address.country
    },
    sameAs: [
      brand.social.facebook,
      brand.social.instagram,
      brand.social.twitter
    ].filter(Boolean) // Remove empty values
  }
};

// Fonction pour générer le titre de page
export const generateTitle = (pageTitle) => {
  if (!pageTitle) return seoConfig.defaultTitle;
  return `${pageTitle} | ${seoConfig.siteName}`;
};

// Fonction pour générer la description
export const generateDescription = (pageDescription) => {
  return pageDescription || seoConfig.defaultDescription;
};

// Fonction pour générer l'URL canonique
export const generateCanonicalUrl = (path) => {
  return `${seoConfig.siteUrl}${path}`;
};

export default seoConfig;
